import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type { FC, PropsWithChildren } from "react";

import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { PropsWithTestId } from "@/components/podkit/lib/testid";

const cardVariants = cva("rounded-xl px-5 py-4", {
    variants: {
        variant: {
            default: "",
            bordered: "border-border-base border-0.5",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

/**
 * Experimental:
 * Cory and I are still working the definitions in the design system, so this is
 * mostly a placeholder for now used on the AI pages.
 */
export const Card: FC<
    PropsWithChildren & PropsWithClassName & VariantProps<typeof cardVariants> & PropsWithTestId & { asChild?: boolean }
> = ({ children, className, asChild, variant, "data-testid": testId }) => {
    const Comp = asChild ? Slot : "div";
    return (
        <Comp
            data-testid={testId}
            className={cn("rounded-xl bg-surface-02 px-5 py-4", cardVariants({ variant }), className)}
        >
            {children}
        </Comp>
    );
};
